if (!customElements.get("th-bv-inline-ratings")) {
  class ThBvInlineRatings extends HTMLElement {
    constructor() {
      super();

      this.RATING_ELEMENT_SELECTOR = ".bv_averageRating_component_container .bv_text";
    }

    connectedCallback() {
      setTimeout(() => {
        this.waitForElm();
      });
    }

    waitForElm() {
      const element = this;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const htmlString = mutation.target.innerHTML;
          if(!htmlString){return}
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          if (doc) {
            this.handleNoRatingsState(doc);
          }
        });
      });

      observer.observe(element, {
        childList: true,
        subtree: true,
      });
    }

    handleNoRatingsState(doc) {
      const ratingEl = doc.querySelector(this.RATING_ELEMENT_SELECTOR);
      if(!ratingEl){return}
      let rating = ratingEl.innerText;
      if(!rating){return}
      rating = parseInt(rating);
      if (rating == 0) {
        this.style.opacity = 0;
      }
    }
  }

  customElements.define("th-bv-inline-ratings", ThBvInlineRatings);
}